import React, {useEffect, useState} from 'react';
import profileImage from '../assets/avater.png'
import {UserInfo} from "../types/interfaces";
import {getLoggedInUser} from "../utils/functions";
import {NavigateFunction, useNavigate} from "react-router-dom";

export const ProfilePage = () => {
    const navigate :NavigateFunction = useNavigate();
    const [currentUser, setCurrentUser] = useState<UserInfo|null>(null);

    useEffect(() :void => {
        const getCurrentUser = async () => {
            const loggedInUser: UserInfo | null = await getLoggedInUser()
            if (loggedInUser === null) {
                navigate('/error')
            }
            setCurrentUser(loggedInUser)
        }
        getCurrentUser()

    }, [navigate]);

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col items-center py-8 px-4">
            {/* Profile Card */}
            <div className="max-w-sm w-full bg-white rounded-lg shadow-lg p-6">
                {/* Avatar */}
                <div className="flex justify-center">
                    <div className="w-24 h-24 rounded-full overflow-hidden border-2 border-white">
                        <img
                            src={profileImage}
                            alt="Profile"
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>

                {/* User Info */}
                <div className="text-center space-y-4 mt-4">
                    <h2 className="text-2xl font-semibold text-gray-800"> {currentUser?.names} </h2>
                    <p className="text-sm text-gray-500">{currentUser?.email}</p>
                </div>

                {/* Stats */}
                <div className="flex justify-around mt-6">
                    <div className="text-center">
                        <h3 className="text-lg font-bold text-gray-800">0</h3>
                        <p className="text-sm text-gray-500">New registrations</p>
                    </div>
                    <div className="text-center">
                        <h3 className="text-lg font-bold text-gray-800">0</h3>
                        <p className="text-sm text-gray-500">Modification</p>
                    </div>
                    <div className="text-center">
                        <h3 className="text-lg font-bold text-gray-800">0</h3>
                        <p className="text-sm text-gray-500">Draft</p>
                    </div>
                </div>

                {/* Edit Profile Button */}
                <div className="mt-6">
                    <button className="w-full bg-green-500 text-white py-2 rounded-lg shadow hover:bg-green-600 transition duration-200">
                        Edit Profile
                        <span className='font-extralight text-xs'> (coming soon)</span>
                    </button>
                </div>
            </div>

            {/* Additional Section */}
            <div className="max-w-4xl w-full mt-8 bg-white rounded-lg shadow-lg p-6">
                <h3 className="text-xl font-semibold text-gray-800 border-b pb-2 mb-4">
                    About Me
                </h3>
                <p className="text-sm text-gray-600 leading-6">
                    Hello! I'm {currentUser?.names}, a BTC employee passionate about becoming the leader in the Telco space.
                </p>
            </div>
        </div>
    );
};

